import ForgotPasswordForm from "../../components/ForgotPasswordForm";
import SEOHead from "../../components/SEO/SEOHead";

export default function ForgotPassword() {
  return (
    <div>
      <SEOHead
        title="Forgot password - Bowling Tournament App"
        description="Reset your Bowling Tournament App password."
        canonicalUrl="/forgot-password"
        noIndex
      />
      <ForgotPasswordForm />
    </div>
  );
}
